export const resources = {
  en: {
    common: {
      appTitle: 'MuseBar POS',
      appTitleFallback: 'POS',
      loading: 'Loading...',
      errorPrefix: 'Error:',
      language: {
        en: 'EN',
        fr: 'FR',
      },
      auth: {
        email: 'Email',
        password: 'Password',
        rememberMe: 'Remember me',
        signIn: 'Sign in',
        networkError: 'Network or server error',
        logout: 'Logout',
      },
      happyHour: {
        active: 'Happy Hour Active!',
        in: 'Happy Hour in {{time}}',
      },
    },
    auth: {
      login: {
        title: 'Sign In',
      },
      passwordResetRequest: {
        title: 'Reset Your Password',
        subtitle: "Enter your email address and we'll send you a link to reset your password.",
        emailLabel: 'Email Address',
        sendLink: 'Send Reset Link',
        sending: 'Sending...',
        success: 'Password reset link has been sent to your email address.',
        nextTitle: 'What happens next?',
        nextStep1: "You'll receive an email with a secure reset link",
        nextStep2: 'Click the link to set a new password',
        nextStep3: 'The link expires in 1 hour for security',
      },
      passwordResetForm: {
        successTitle: 'Password Reset Successfully!',
        successSubtitle: 'Your password has been updated. You can now log in with your new password.',
        goToLogin: 'Go to Login',
        title: 'Set New Password',
        subtitle: 'Create a strong password for your account.',
        newPassword: 'New Password',
        confirmPassword: 'Confirm New Password',
        weak: 'Weak',
        fair: 'Fair',
        strong: 'Strong',
        criteriaMet: '{{count}}/5 criteria met',
        criteria: {
          length: 'At least 8 characters',
          lowercase: 'Lowercase letter',
          uppercase: 'Uppercase letter',
          number: 'Number',
          special: 'Special character',
        },
        passwordsDoNotMatch: 'Passwords do not match',
        updating: 'Updating Password...',
        updatePassword: 'Update Password',
      },
    },
  },
  fr: {
    common: {
      appTitle: 'MuseBar POS',
      appTitleFallback: 'POS',
      loading: 'Chargement...',
      errorPrefix: 'Erreur :',
      language: {
        en: 'EN',
        fr: 'FR',
      },
      auth: {
        email: 'Email',
        password: 'Mot de passe',
        rememberMe: 'Rester connecte',
        signIn: 'Se connecter',
        networkError: 'Erreur reseau ou serveur',
        logout: 'Deconnexion',
      },
      happyHour: {
        active: 'Happy Hour actif !',
        in: 'Happy Hour dans {{time}}',
      },
    },
    auth: {
      login: {
        title: 'Connexion',
      },
      passwordResetRequest: {
        title: 'Reinitialiser votre mot de passe',
        subtitle: 'Saisissez votre email et nous vous enverrons un lien de reinitialisation.',
        emailLabel: 'Adresse email',
        sendLink: 'Envoyer le lien',
        sending: 'Envoi...',
        success: 'Le lien de reinitialisation a ete envoye a votre adresse email.',
        nextTitle: 'Que se passe-t-il ensuite ?',
        nextStep1: 'Vous recevrez un email avec un lien securise',
        nextStep2: 'Cliquez sur le lien pour definir un nouveau mot de passe',
        nextStep3: 'Le lien expire dans 1 heure pour des raisons de securite',
      },
      passwordResetForm: {
        successTitle: 'Mot de passe reinitialise avec succes !',
        successSubtitle: 'Votre mot de passe a ete mis a jour. Vous pouvez maintenant vous connecter.',
        goToLogin: 'Aller a la connexion',
        title: 'Definir un nouveau mot de passe',
        subtitle: 'Creez un mot de passe fort pour votre compte.',
        newPassword: 'Nouveau mot de passe',
        confirmPassword: 'Confirmer le nouveau mot de passe',
        weak: 'Faible',
        fair: 'Moyen',
        strong: 'Fort',
        criteriaMet: '{{count}}/5 criteres remplis',
        criteria: {
          length: 'Au moins 8 caracteres',
          lowercase: 'Lettre minuscule',
          uppercase: 'Lettre majuscule',
          number: 'Chiffre',
          special: 'Caractere special',
        },
        passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
        updating: 'Mise a jour du mot de passe...',
        updatePassword: 'Mettre a jour le mot de passe',
      },
    },
  },
} as const;

export type AppLanguage = 'en' | 'fr';
